if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        const formData = new FormData(this.form);
        const shouldAddAutomaticGiftFirst = await this.shouldAddAutomaticGiftFirst(formData);

        if (shouldAddAutomaticGiftFirst) {
          config.headers['Content-Type'] = 'application/json';
        } else {
          delete config.headers['Content-Type'];
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = shouldAddAutomaticGiftFirst ? this.buildAddItemsBody(formData) : formData;

        fetch(`${ThatWorks.shopSettings.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.ThatWorks.shopSettings.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      async shouldAddAutomaticGiftFirst(formData) {
        const automaticGiftSettings = window.ThatWorks?.shopSettings?.automaticGift;
        const isAutomaticGiftEnabled = Boolean(automaticGiftSettings?.enabled);
        const automaticGiftVariantId = Number(automaticGiftSettings?.variantId);
        const hasValidAutomaticGiftVariant = Number.isFinite(automaticGiftVariantId) && automaticGiftVariantId > 0;

        if (!isAutomaticGiftEnabled || !hasValidAutomaticGiftVariant) return false;

        if (!this.cart || this.tagName !== 'PRODUCT-FORM') return false;

        const productVariantId = Number(formData.get('id'));

        if (Number.isNaN(productVariantId) || productVariantId === automaticGiftVariantId) return false;

        try {
          const response = await fetch(`${ThatWorks.shopSettings.routes.cart_url}.js`);

          if (!response.ok) return false;

          const cart = await response.json();
          const cartItems = cart.items || [];
          const hasAutomaticGiftLine = cartItems.some((item) => {
            return (
              Number(item.variant_id) === automaticGiftVariantId &&
              item.properties &&
              item.properties._automatic_gift === 'true'
            );
          });

          return !hasAutomaticGiftLine;
        } catch {
          return false;
        }
      }

      buildAddItemsBody(formData) {
        const automaticGiftVariantId = Number(window.ThatWorks?.shopSettings?.automaticGift?.variantId);
        const productVariantId = Number(formData.get('id'));
        const productQuantity = Number(formData.get('quantity')) || 1;
        const body = {
          items: [
            {
              id: automaticGiftVariantId,
              quantity: 1,
              properties: {
                _automatic_gift: 'true',
              },
            },
            {
              id: productVariantId,
              quantity: productQuantity,
            },
          ],
          sections: this.cart.getSectionsToRender().map((section) => section.id).join(','),
          sections_url: window.location.pathname,
        };

        return JSON.stringify(body);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
